import axios from "axios";
import config from "../../../config";
import Cookies from "js-cookie";

const baseUrl = config.baseUrl; // URL base de tu API
const endpointFormatoAceptacion = "/api/financiero/formato-aceptacion"; // Endpoint base sin slash final
const endpoint = "/api/financiero/data-formato-aceptacion"; // Endpoint base sin slash final

const api = axios.create({
  baseURL: baseUrl,
});

api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Obtener datos del formato de aceptación por ID
 * @param {number|string} id - ID del plan de compra
 * @returns {Promise<Object>} Datos o error
 */
export const getDataFormatoAceptacionPlanCompraPatti = async (id) => {
  try {
    if (!id) throw new Error("ID es requerido");
    const response = await api.get(`${endpoint}/${id}`);
    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener los datos:", error.message || error);
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al obtener los datos",
    };
  }
};

export const postFormatoAceptacionPlanCompraPatti = async (payload) => {
  try {
    const response = await api.post(`${endpointFormatoAceptacion}`, payload);
    return response.data;
  } catch (error) {
    console.error("❌ Error al registrar el formato:", error.message || error);
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al registrar el formato",
    };
  }
};

export const putFormatoAceptacionPlanCompraPatti = async (id, payload) => {
  try {
    const response = await api.put(
      `${endpointFormatoAceptacion}/${id}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error al actualizar el formato:", error.message || error);
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al actualizar el formato",
    };
  }
};

export const getFormatoAceptacionPattiById = async (id, tipo_formato) => {
  try {
    if (!id) throw new Error("ID es requerido");

    const response = await api.get(
      `${endpointFormatoAceptacion}/${id}/${tipo_formato}`
    );

    // Retorna los datos (puede ser {success: true, data: [...]})
    return response.data;
  } catch (error) {
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al obtener formato de aceptación PATTI",
    };
  }
};
export const uploadFormatoAceptacion = async (
  blobArchivo,
  blobCedula,
  idRegistro,
  estado,
  nombreArchivo,
  nombreCedula,
  tipo_formato,
  codigo_interno,
  username,
  codigoIngresado
) => {
  try {
    if (!idRegistro) throw new Error("ID de registro es requerido");
    if (!tipo_formato) throw new Error("tipo_formato de registro es requerido");
    if (!codigo_interno)
      throw new Error("codigo_interno de registro es requerido");

    if (estado === undefined || estado === null)
      throw new Error("estado es requerido");

    const formData = new FormData();

    formData.append("id_registro", idRegistro);
    formData.append("estado", estado);
    formData.append("nombreArchivo", nombreArchivo);
    formData.append("nombreCedula", nombreCedula);
    formData.append("tipo_formato", tipo_formato);
    formData.append("codigo_interno", codigo_interno);
    formData.append("username", username); // Agrega el username si está disponible
    formData.append("codigoIngresado", codigoIngresado); // Agrega el username si está disponible


    if (blobArchivo) {
      const file = new File([blobArchivo], nombreArchivo, {
        type: "application/pdf",
      });
      formData.append("archivo", file);
    }

    if (blobCedula) {
      const cedulaFile = new File([blobCedula], nombreCedula, {
        type: "application/pdf",
      });
      formData.append("cedula", cedulaFile);
    }

    const response = await api.post(
      `${endpointFormatoAceptacion}/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error al subir archivo formato aceptación:", error);

    return {
      status: error.response ? error.response.status : 500,
      // Si la respuesta viene del backend, toma el mensaje o el errorCode que envía
      message:
        error.response?.data?.message ||
        error.message ||
        "Error al subir archivo formato aceptación",
      errorCode: error.response?.data?.errorCode || null,
    };
  }
};
